<template>
  <section id="services" class="section-padding bg-gray">
    <div class="container-fluid">
      <div class="section-header text-center container">
        <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">{{$t('aboutUs.title')}}</h2>
        <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
        <p class="wow fadeInDown" data-wow-delay="0.4s">{{$t('aboutUs.subtitle')}}</p>
      </div>
      <div class="row">
        <!-- About Us item -->
        <div class="col-md-6 col-lg-3 col-xs-12">
          <div class="services-item wow fadeInLeft" data-wow-delay="0.3s">
            <div class="icon">
              <img class="img-fluid" src="../assets/img/about/person-centered.svg" alt="">
            </div>
            <div class="services-content">
              <h3>{{$t('aboutUs.txt1')}}</h3>
              <p>{{$t('aboutUs.sub1')}}</p>
              <button style="margin: auto" v-b-modal.modal-about-us-1 class="btn btn-border mt-3 line-out">{{$t('readMore')}}</button>
            </div>
          </div>
        </div>
        <!-- Services item -->
        <div class="col-md-6 col-lg-3 col-xs-12">
          <div class="services-item wow fadeInRight" data-wow-delay="0.6s">
            <div class="icon">
              <img class="img-fluid" src="../assets/img/about/mision.svg" alt="">
            </div>
            <div class="services-content">
              <h3>{{$t('aboutUs.txt2')}}</h3>
              <p>{{$t('aboutUs.sub2')}}</p>
            </div>
          </div>
        </div>
        <!-- Services item -->
        <div class="col-md-6 col-lg-3 col-xs-12">
          <div class="services-item wow fadeInLeft" data-wow-delay="0.6s">
            <div class="icon">
              <img class="img-fluid" src="../assets/img/about/vision.svg" alt="">
            </div>
            <div class="services-content">
              <h3>{{$t('aboutUs.txt3')}}</h3>
              <p>{{$t('aboutUs.sub3')}}</p>
            </div>
          </div>
        </div>
        <!-- Services item -->
        <div class="col-md-6 col-lg-3 col-xs-12">
          <div class="services-item wow fadeInRight" data-wow-delay="0.6s">
            <div class="icon">
              <img class="img-fluid" src="../assets/img/about/values.svg" alt="">
            </div>
            <div class="services-content">
              <h3>{{$t('aboutUs.txt4')}}</h3>
              <ul>
                <li>{{$t('aboutUs.list.li1')}}</li>
                <li>{{$t('aboutUs.list.li2')}}</li>
                <li>{{$t('aboutUs.list.li3')}}</li>
                <li>{{$t('aboutUs.list.li4')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "About"
  }
</script>

<style scoped>

</style>
